import type { Components, Theme } from '@mui/material';
import { fontFamily } from '@/@mui/tokens/font-family';
import { pxToRem } from '@/@mui/utils/px-to-rem';
import { fontWeights } from '../tokens/font-weights';

const CHIP_COLORS = [
  'primary',
  'secondary',
  'error',
  'warning',
  'info',
  'success',
] as const;

export const MuiChip: Components<Theme>['MuiChip'] = {
  styleOverrides: {
    deleteIcon: { fontSize: pxToRem(16) },
    root: ({ theme }) => {
      return {
        borderRadius: theme.shape.borderRadius,
        fontFamily: fontFamily.fontFamilyCarbona,
        fontWeight: fontWeights.fontWeightSemibold,
        height: 'auto',

        '& span': { padding: '4px 10px' },
        '& svg': { fontSize: pxToRem(16) },

        variants: [
          {
            props: { variant: 'filled', color: 'default' },
            style: {
              backgroundColor: theme.palette.primary.light,
              color: theme.palette.primary.dark,
              '& svg': { color: `${theme.palette.primary.dark} !important` },
            },
          },
          ...CHIP_COLORS.map((color) => ({
            props: { variant: 'filled', color },
            style: {
              backgroundColor: theme.palette[color].light,
              color: theme.palette[color].dark,
              '& svg': { color: `${theme.palette[color].dark} !important` },
            },
          })),
          ...CHIP_COLORS.map((color) => ({
            props: { variant: 'outlined', color },
            style: {
              borderColor: theme.palette[color].main,
              color: theme.palette[color].dark,
              '& svg': { color: `${theme.palette[color].dark} !important` },
            },
          })),
        ],
      };
    },
  },
};
